<template>
    <div class="container">
        <div class="container-header">
            <div class="search">
                <div class="search-handle">
                    <el-button type="primary"
                               size="mini"
                               @click="skipRoleHandle()"
                               v-permission="['emp:role-create']">{{ $t('add') }}</el-button>
                </div>
            </div>
        </div>
        <div class="container-main">
            <el-table :data="tableData"
                      border
                      style="width: 100%">
                <el-table-column type="index"
                                 align="center"
                                 width="60"></el-table-column>
                <el-table-column prop="name"
                                 :label="$t('roleName')"
                                 align="center"
                                 width="180"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('whetherEnable')"
                                 align="center"
                                 width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.enabled">{{ $t('yes') }}</span>
                        <span v-else>{{ $t('no') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remark"
                                 :label="$t('remark')"
                                 align="center"
                                 min-width="180"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column class-name="handle"
                                 :label="$t('handle')"
                                 align="center"
                                 fixed="right"
                                 width="180">
                    <template slot-scope="scope">
                        <el-button type="text"
                                   size="mini"
                                   @click="skipRoleHandle(scope.row.id)"
                                   v-permission="['emp:role-update']">{{ $t('edit') }}
                        </el-button>
                        <el-button class="red"
                                   type="text"
                                   size="mini"
                                   @click="deleteHandle(scope.row.id)"
                                   v-permission="['emp:role-delete']">{{$t('delete')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>

import { deleteRole, searchRoleList } from "@/api/modules/user";

export default {
    name: "Role",
    // 组件
    components: {},
    props: {},
    data () {
        return {
            tableData: [],
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取数据列表
        getListData () {
            searchRoleList().then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },

        // 删除
        deleteHandle (id) {
            this.$confirm(this.$t('deleteItemHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                deleteRole(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => { })
        },
        // 跳转操作页面
        skipRoleHandle (id = '') {
            if (id) {
                this.$router.push({
                    path: '/employee/role-handle',
                    query: {
                        id
                    }
                })
            } else {
                this.$router.push({
                    path: '/employee/role-handle',
                })
            }
        },
    },
    // 创建完成
    created () {
    },
    // 挂载完成
    mounted () {
        // 获取数据列表
        this.getListData()
    },
    // 销毁之前
    beforeDestroy () {
    }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';
</style>
